//user reducer types
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATEED = "SET_UNAUTHENTICATEED";
export const SET_USER = "SET_USER";
export const LOADING_USER = "LOADING_USER";
//UI reducer types
export const SET_ERRORS = "SET_ERRORS";
export const SET_SUCCESS = "SET_SUCCESS";
export const LOADING_UI = "LOADING_UI";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
//Data reducer types
export const LOADING_DATA = "LOADING_DATA";
export const SET_DATA = "SET_DATA";
export const SET_PONTO = "SET_PONTO";

//Empresa reducer types
export const SET_EMPRESA = "SET_EMPRESA";
export const LOADING_EMPRESA = "LOADING_EMPRESA";
